import React, { useCallback, useMemo } from "react";
import { useLocation, useHistory, useParams } from "react-router-dom";
import { ToggleButtonGroup } from "@material-ui/lab";
import { ViewToggleButton } from "../../../components/ViewToggleButton";
import { styled } from "@material-ui/core";

export enum ViewType {
  Transactions = "Transactions",
  Bills = "Bills",
  Payments = "Payments",
}

const getPath = (accountNumber: string, view: ViewType) => {
  const basePath = `/accounts/${accountNumber}/financials`;
  if (view !== ViewType.Transactions) {
    return `${basePath}/${String(view).toLocaleLowerCase()}`;
  }
  return basePath;
};

const StyledViewToggleButton = styled(ViewToggleButton)(({ theme }) => ({
  width: "118px",
}));

export const ViewSelector: React.FC = () => {
  const { pathname } = useLocation();
  const { accountNumber } = useParams();

  const view = useMemo(() => {
    const parts = pathname.split("/");
    const index = parts.findIndex((p) => p === "financials");
    if (index >= 0) {
      const page = parts[index + 1];
      switch (page) {
        case ViewType.Bills.toLocaleLowerCase():
          return ViewType.Bills;
        case ViewType.Payments.toLocaleLowerCase():
          return ViewType.Payments;
      }
    }
    return ViewType.Transactions;
  }, [pathname]);

  const { push } = useHistory();
  const handleChange = useCallback(
    (_event: any, value: ViewType) => {
      if (value) {
        push(getPath(accountNumber, value));
      }
    },
    [accountNumber, push],
  );

  return (
    <ToggleButtonGroup exclusive value={view} onChange={handleChange}>
      <StyledViewToggleButton
        value={ViewType.Transactions}
        href={getPath(accountNumber, ViewType.Transactions)}
      />
      <StyledViewToggleButton
        value={ViewType.Bills}
        href={getPath(accountNumber, ViewType.Bills)}
      />
      <StyledViewToggleButton
        value={ViewType.Payments}
        href={getPath(accountNumber, ViewType.Payments)}
      />
    </ToggleButtonGroup>
  );
};
